module.exports = __webpack_public_path__ + "static/media/jimmy-script-regular.0f532352.woff";